export default async function init() {
  const elements = document.querySelectorAll('.main-stage');

  const { default: MainStage } = await import(/* webpackChunkName: "main-stage" */ './main-stage');

  elements.forEach((element) => new MainStage(element));
}
